module.exports = __webpack_public_path__ + "img/my-account-mobile-ru.6c9b652e.jpg";